
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetDeptData } from "@/request/common";
import { BuildTree } from "@/utils/base";
@Component({})
export default class Name extends Vue {
  @Prop({ type: Number, default: 200 })
  private width: any; // 树内容宽度,影响文字超出。。。
  @Prop()
  private id: any;
  @Watch("id", { immediate: true })
  private idChange() {
    this.init();
  }
  private data: any = [];
  private handleNodeClick(data: any, node: any) {
    this.$emit("change", data.id);
  }
  private init() {
    if (this.id) {
      this.$nextTick(() => {
        (this.$refs.zuzhiTree as any).setCurrentKey(this.id);
      });
    } else {
      this.$nextTick(() => {
        (this.$refs.zuzhiTree as any).setCurrentKey(null);
      });
    }
  }
  private defaultProps: any = {
    children: "children",
    label: "name",
  };
  /**
   * @description 获取组织架构列表
   */
  private getJigouList() {
    const params: any = {
      params: {},
    };
    GetDeptData(this, params).then((data: any) => {
      this.data = BuildTree(data.data);
      this.init();
    });
  }
  private mounted() {
    this.getJigouList();
  }
}
